var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowArcright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 11.5001C1.5 11.6327 1.55268 11.7599 1.64645 11.8537C1.74021 11.9474 1.86739 12.0001 2 12.0001C2.13261 12.0001 2.25979 11.9474 2.35355 11.8537C2.44732 11.7599 2.5 11.6327 2.5 11.5001C2.50013 10.4124 2.82277 9.34918 3.42713 8.44483C4.03149 7.54049 4.89042 6.83564 5.89533 6.41941C6.90024 6.00319 8.006 5.89427 9.07281 6.10643C10.1396 6.3186 11.1196 6.84231 11.8888 7.61136L13.2875 9.00011H10.5C10.3674 9.00011 10.2402 9.05279 10.1464 9.14656C10.0527 9.24033 10 9.36751 10 9.50011C10 9.63272 10.0527 9.7599 10.1464 9.85367C10.2402 9.94744 10.3674 10.0001 10.5 10.0001H14.5C14.6326 10.0001 14.7598 9.94744 14.8536 9.85367C14.9473 9.7599 15 9.63272 15 9.50011V5.50011C15 5.36751 14.9473 5.24033 14.8536 5.14656C14.7598 5.05279 14.6326 5.00011 14.5 5.00011C14.3674 5.00011 14.2402 5.05279 14.1464 5.14656C14.0527 5.24033 14 5.36751 14 5.50011V8.29824L12.595 6.90262C11.6858 5.9939 10.5276 5.37517 9.26682 5.12465C8.00602 4.87412 6.69925 5.00305 5.51173 5.49513C4.3242 5.98721 3.30924 6.82035 2.59517 7.88922C1.88109 8.95808 1.49998 10.2147 1.5 11.5001Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowArcright);
export default __webpack_public_path__ + "static/media/ArrowArcright.529ef1bb94e292eeb83715e2b6624584.svg";
export { ForwardRef as ReactComponent };